import { render, staticRenderFns } from "./dialog-info.vue?vue&type=template&id=b81d95a8&scoped=true"
import script from "./dialog-info.vue?vue&type=script&lang=js"
export * from "./dialog-info.vue?vue&type=script&lang=js"
import style0 from "./dialog-info.vue?vue&type=style&index=0&id=b81d95a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81d95a8",
  null
  
)

export default component.exports